import { attempt } from "@omni/utils/function.utils";
import { isDefined } from "@omni/utils/helper.utils";

export type RenderFeatureValues = {
    formattedValues: Array<string>;
    unitName?: string | null;
};

export const displayFeature = (
    feature?: RenderFeatureValues | null
): string => {
    if (!feature) return "";

    const { formattedValues, unitName } = feature;

    const featureValue = attempt(
        () =>
            formattedValues.filter((v) => isDefined(v) && v !== "").join(", "),
        ""
    );
    const featureUnit = unitName ? ` ${unitName}` : "";

    return `${featureValue}${featureUnit}`;
};
